// extracted by mini-css-extract-plugin
export default {"editorXTemplateDemo":"dI4HjK","iframe":"ojXpWM","tablet":"XZORkI","mobile":"yzOWsG"};